import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { QueryState } from '@/components/feedback/query-state';
import { SkeletonTable } from '@/components/feedback/skeletons';
import { PageHeader } from '@/components/page-header';
import { MarketSwitch } from '@/components/switches/market-switch';
import { SwitchList } from '@/components/switches/switch-list';
import type { OpsStatus } from '@/lib/home-model';
import { adminQuery } from '@/lib/query';

export const Route = createFileRoute('/_app/switches')({
  component: SwitchesPage,
});

/** Stop a money service for every customer at once. */
function SwitchesPage() {
  const status = useQuery({
    ...adminQuery('ops.status', {}),
    refetchInterval: 30_000,
  });
  return (
    <>
      <PageHeader
        title="Kill switches"
        description="Stop a money service for every customer at once. A service runs only when its server config and this setting are both on."
      />
      <QueryState
        query={status}
        label="the kill switches"
        skeleton={<SkeletonTable columns={2} />}
      >
        {(data) => {
          const ops = data as unknown as OpsStatus;
          return (
            <>
              <MarketSwitch />
              {ops.switches ? <SwitchList switches={ops.switches} /> : null}
            </>
          );
        }}
      </QueryState>
    </>
  );
}
